import React, { useState } from "react";

import { getUser } from "../../state/User";
import { DestinationType, TWITTER_MAX_CHAR_LIMIT } from "../../constants";
import Close from "../utils/icons/Close";
import Check from "../utils/icons/Check";
import { THEMES, LANGUAGES } from "./codeSnippetConfigs";
import Dropdown from "../utils/Dropdown";
import Checkbox from "../utils/Checkbox";
import { useForm } from "../../state/Form";
import { toSafeFilename } from "../helpers";
import ColorPicker from "../utils/ColorPicker";
import Tabs from "../utils/Tabs";

export const TYPE_OF_TEXT = {
  PLAIN_TEXT: "PLAIN_TEXT",
  CODE_SNIPPET: "CODE_SNIPPET",
};

export default function ContentText({
  onClose,
  onSave,
  defaultText,
  defaultTypeOfText,
}: ContentTextTypes) {
  const [text, setText] = useState(defaultText || "");
  const [typeOfText, setTypeOfText] = useState(
    defaultTypeOfText ? defaultTypeOfText : TYPE_OF_TEXT.PLAIN_TEXT
  );
  const user = getUser();
  const { setFieldValue, getFormValue } = useForm();
  const isCodeSnippet = typeOfText === TYPE_OF_TEXT.CODE_SNIPPET;

  return (
    <div>
      {!defaultText && (
        <Tabs
          buttonWidth={120}
          items={[
            {
              label: "Plain text",
              onClick: () => setTypeOfText(TYPE_OF_TEXT.PLAIN_TEXT),
            },
            {
              label: "Code snippet",
              onClick: () => setTypeOfText(TYPE_OF_TEXT.CODE_SNIPPET),
            },
          ]}
          className="mb1"
        />
      )}
      <div className="grid4">
        {isCodeSnippet && (
          <>
            <Dropdown
              className="mb1 mr1"
              name="theme"
              onChange={setFieldValue}
              data={THEMES}
              storageKey="contempas_theme"
              defaultValue="Cobalt2"
              description={
                <>
                  All available themes{" "}
                  <a href="https://iterm2colorschemes.com/" target="_blank">
                    here
                  </a>
                  .
                </>
              }
            />
            <Dropdown
              name="language"
              onChange={setFieldValue}
              data={LANGUAGES}
              storageKey="contempas_language"
              defaultValue="javascript"
              description={
                <>
                  Supported languages{" "}
                  <a
                    href="https://github.com/highlightjs/highlight.js/tree/main/src/languages"
                    target="_blank"
                  >
                    here
                  </a>
                  .
                </>
              }
            />
            <div>
              <Checkbox
                label="Use frame"
                name="frame"
                onChange={setFieldValue}
                defaultValue={true}
                storageKey="contempas_useFrame"
              />
              <Checkbox
                label="Line numbers"
                name="lineNumbers"
                onChange={setFieldValue}
                defaultValue={true}
                storageKey="contempas_lineNumbers"
              />
            </div>
            <div>
              Background color:
              <ColorPicker
                className="mt05"
                name="backgroundColor"
                defaultColor="#999999"
                onChange={(newColor) => {
                  setFieldValue("backgroundColor", newColor);
                }}
              />
            </div>
          </>
        )}
      </div>
      <textarea
        rows={10}
        autoFocus
        onChange={(e) => setText(e.target.value)}
        value={text}
      />
      <div className="cf mt1">
        {text !== "" && !isCodeSnippet && getTextAnalysis(text, user)}
        <div className="left">
          {isCodeSnippet && (
            <input
              type="text"
              className="block fz08"
              name="filename"
              placeholder="Filename"
              onChange={(e) =>
                setFieldValue("filename", toSafeFilename(e.target.value))
              }
            />
          )}
        </div>
        <div className="right">
          <button
            type="button"
            className="reset as-link ib fz1 with-icon"
            onClick={() => onClose()}
          >
            <Close size={20} /> Cancel
          </button>
          <button
            type="button"
            className="reset secondary ml1 with-icon"
            onClick={() => {
              onSave(text, { ...getFormValue(), typeOfText });
            }}
            disabled={text === ""}
          >
            <>
              <Check size={16} /> Save
            </>
          </button>
        </div>
      </div>
    </div>
  );
}

function getTextAnalysis(text, user) {
  return (
    <>
      <small className={"op05 fz08"}>{text.length}</small>
    </>
  );
}
